<template>
  <div class="dashboard-tiempos-x-zona">
    <div class="linea-zona">
      <div class="zona-nombre">{{ item.zona.nombre }}</div>
      <div class="campo-tiempo">
        {{ item.tiempoAsignacion }}
      </div>
      <div class="campo-tiempo">{{ item.tiempoPicking }}</div>
      <div class="campo-tiempo">{{ item.tiempoDespacho }}</div>
      <div class="campo-tiempo">
        <b-tag :type="item.colorTiempoPromedio" size="is-large">
          {{ item.tiempoTotal }}
        </b-tag>
      </div>
      <div class="campo-tiempo">{{ item.metaPromedio }}</div>
      <div class="campo-tiempo">
        <b-tag :type="item.colorTiempoMaximo" size="is-large">{{
          item.porcentajeBajoTope
        }}</b-tag>
      </div>
      <div class="campo-tope">80&percnt; bajo {{ item.metaTiempoTope }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TiempoPorZonaItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
.linea-zona {
  border-radius: 5px;
  border: 3px solid #0f24cc;
  color: #0f24cc;
  padding: 0 15px;
  margin: 10px 0;

  &:hover {
    border-color: rgba(213, 117, 45, 1);
  }

  .zona-nombre {
    margin: 10px 0;
    width: 25%;
    display: inline-block;
  }

  .campo-tiempo {
    margin: 10px 0;
    display: inline-block;
    text-align: center;
    width: 9.5%;
  }

  .campo-tope {
    margin: 10px 0;
    display: inline-block;
    width: 18%;
  }
}
</style>
